<template>
    <div class="fullForecastContainer" :class="{'fullForecastContainerDark' : isDark}">
        <TitleBar title="全维预测" :txt="txt" :type="type"></TitleBar>
        <div class="fullForecastBox" v-if="allData.is_pay === 0">
            <div class="fullForecastCard left" @click="goModelList">
                <div class="top">
                    <p class="team"><span>{{allLeft.home_team}}</span><em> {{allLeft.home_score}}:{{allLeft.guest_score}} </em><span class="r">{{allLeft.guest_team}}</span></p>
                    <p class="result" v-if="leftResult.length > 0">{{leftResult.join('、')}} <em>命中</em></p>
                </div>
                <div class="btm">
                    <span class="league" :style="{color: allLeft.sclass_color}">{{allLeft.sclass_name}}</span>
                    <span class="time">{{matchTimeLeft}}</span>
                </div>
            </div>
            <div class="fullForecastCard" @click="goModelList">
                <div class="top">
                    <p class="team"><span>{{allRight.home_team}}</span><em> {{allRight.home_score}}:{{allRight.guest_score}} </em><span class="r">{{allRight.guest_team}}</span></p>
                    <p class="result" v-if="rightResult.length > 0">{{rightResult.join('、')}} <em>命中</em></p>
                </div>
                <div class="btm">
                    <span class="league" :style="{color: allRight.sclass_color}">{{allRight.sclass_name}}</span>
                    <span class="time">{{matchTimeRight}}</span>
                </div>
            </div>
        </div>
        <div class="coldBox" v-if="allData.is_pay === 1">
            <div class="coldCard left" @click="goModelList">
                <p>{{allLeft.home_team}}</p>
                <p>{{allLeft.guest_team}}</p>
                <div class="btm">
                    <span class="league" :style="{color: allLeft.sclass_color}">{{allLeft.sclass_name}}</span>
                    <span class="time">{{matchTimeLeft}}</span>
                </div>
                <div class="result">
                    <p>
                        <ChartsPie
                            id="fullPieLeft"
                            :colors = "['#FF5048',isDark ? '#2f2f2f':'#eeeeee']"
                            :data="[allLeft.rec_value*1, 100 - allLeft.rec_value*1]"
                            type="full"
                            :text="allLeft.rec_value*1 + '%'"
                        />
                    </p>
                    <p>{{allLeft.rec_name === '胜' ? '主胜概率' : '客胜概率'}}</p>
                </div>
            </div>
            <div class="coldCard" @click="goModelList">
                <p>{{allRight.home_team}}</p>
                <p>{{allRight.guest_team}}</p>
                <div class="btm">
                    <span class="league" :style="{color: allRight.sclass_color}">{{allRight.sclass_name}}</span>
                    <span class="time">{{matchTimeRight}}</span>
                </div>
                <div class="result">
                    <p>
                        <ChartsPie
                            id="fullPieRight"
                            :colors = "['#FF5048',isDark ? '#2f2f2f':'#eeeeee']"
                            :data="[allRight.rec_value*1, 100 - allRight.rec_value*1]"
                            type="full"
                            :text="allRight.rec_value*1 + '%'"
                        />
                    </p>
                    <p>{{allRight.rec_name === '胜' ? '主胜概率' : '客胜概率'}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from './common/titleBar.vue'
import ChartsPie from './common/chartsPie.vue'
export default {
    name: 'fullForecastCorpus',
    props: ['allData'],
    components: {
        TitleBar,
        ChartsPie
    },
    watch: {
        data: {
            handler () {
                this.renderAllList();
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    data () {
        return {
            type: "16",
            txt: '',
            allLeft: {},
            allRight: {},
            matchTimeLeft: '',
            matchTimeRight: '',
            leftResult: [], // 命中结果
            rightResult: []
        }
    },
    methods: {
        renderAllList () {
            if (this.allData) {
                this.allLeft = this.allData.list[0];
                this.allRight = this.allData.list[1];
                if (this.allData.list[0]) {
                    if (this.allData.list[0].totalscore_hit === 1) {
                        this.leftResult.push('大小球');
                    }
                    if (this.allData.list[0].standard_hit === 1) {
                        this.leftResult.push('胜平负');
                    }
                    if (this.allData.list[0].letgoal_hit === 1) {
                        this.leftResult.push('让球');
                    }
                }
                if (this.allData.list[1]) {
                    if (this.allData.list[1].totalscore_hit === 1) {
                        this.rightResult.push('大小球');
                    }
                    if (this.allData.list[1].standard_hit === 1) {
                        this.rightResult.push('胜平负');
                    }
                    if (this.allData.list[1].letgoal_hit === 1) {
                        this.rightResult.push('让球');
                    }
                }
                this.matchTimeLeft = this.allData.list[0].match_time.substring(5, 16).replace('-', '月');
                this.matchTimeRight = this.allData.list[1].match_time.substring(5, 16).replace('-', '月');
                if (this.allData.type_num * 1 > 0) {
                    this.txt = '（近3日命中' + this.allData.type_num + '场）';
                } else {
                    this.txt = '';
                }
            }
        },
        goModelList () {
            this.$emit('goDetail', this.type);
        }
    }
}
</script>

<style lang="less" scoped>
.fullForecastContainer{
    width: 100%;
    .fullForecastBox{
        width: 100%;
        padding: 0 14px;
        overflow: hidden;
        .fullForecastCard{
            position: relative;
            display: inline-block;
            width: 48%;
            height: auto;
            padding: 8px 10px 0;
            background: #FFFFFF;
            border-radius: 5px;
            text-align: left;
            &.left{
                margin-right: 4%;
            }
            .top{
                .team{
                    font-size: 12px;
                    font-weight: bold;
                    color: #333333;
                    span{
                        display: inline-block;
                        max-width: 40%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        vertical-align: middle;
                        &.r{
                            text-align: right;
                        }
                    }
                    em{
                        color: #FF5048;
                        vertical-align: middle;
                    }
                }
                .result{
                    margin-top: 8px;
                    font-size: 10px;
                    color: #333333;
                    em{
                        font-size: 9px;
                        color: #FFFFFF;
                        background: #FF5048;
                        border-radius: 2px;
                        padding: 0 2px;
                    }
                }
            }
            .btm{
                width: 100%;
                height: 30px;
                line-height: 30px;
                margin-top: 10px;
                font-size: 10px;
                border-top: 1px solid #EEEEEE;
                .league{
                    float: left;
                    height: 30px;
                }
                .team{
                    color: #333333;
                    em{
                        color: #FF5048;
                    }
                }
                .time{
                    float: right;
                    height: 30px;
                    color: #999999;
                }
            }
        }
    }
    .coldBox{
        width: 100%;
        height: auto;
        padding: 0 14px;
        overflow: hidden;
        .coldCard{
            position: relative;
            display: inline-block;
            width: 48%;
            height: auto;
            padding: 10px 10px 0;
            background: #FFFFFF;
            border-radius: 5px;
            text-align: left;
            &.left{
                margin-right: 4%;
            }
            >p{
                margin-bottom: 8px;
                font-size: 12px;
                font-weight: bold;
                color: #333333;
                max-width: 105px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &.margin{
                    position: relative;
                    width: 70px;
                    max-width: 70px;
                    padding-right: 5px;
                    span{
                        position: absolute;
                        right: 0;
                        font-size: 13px;
                        font-weight: bold;
                        color: #FF5048;
                    }
                }
            }
            .btm{
                width: 100%;
                height: 30px;
                line-height: 30px;
                margin-top: 10px;
                font-size: 10px;
                border-top: 1px solid #EEEEEE;
                .league{
                    float: left;
                    height: 30px;
                    color: #BE2FD1;
                }
                .team{
                    color: #333333;
                    em{
                        color: #FF5048;
                    }
                }
                .time{
                    float: right;
                    height: 30px;
                    color: #999999;
                }
            }
            .result{
                position: absolute;
                top: 7px;
                right: 6px;
                font-size: 10px;
                color: #333333;
                text-align: center;
                >p{
                    font-weight: normal;
                }
                .val{
                    font-size: 20px;
                    font-weight: bold;
                    color: #FF5048;
                    &.margin{
                        font-size: 15px;
                        margin-top: 8px;
                    }
                }
                .odds{
                    height: 36px;
                    img{
                        width: 36px;
                        height: 36px;
                        border-radius: 50%;
                    }
                }
            }
        }
    }
}
.fullForecastContainerDark {
    background: #191919;
    .fullForecastBox {
        .fullForecastCard {
            background: #232323;
            .top {
                .team {
                    color: #d3d3d3;
                }
                .result {
                    color: #a6a6a6;
                }
            }
            .btm {
                border-color: #2f2f2f;
                .team {
                    color: #d3d3d3;
                }
                .time {
                    color: #a6a6a6;
                }
            }
        }
    }
    .coldBox{
        .coldCard{
            background: #232323;
            >p{
                color: #d3d3d3;
            }
            .btm{
                border-color: #2f2f2f;
                .team{
                    color: #d3d3d3;
                }
                .time{
                    color: #595959;
                }
            }
            .result{
                color: #d6d6d6;
            }
        }
    }
}
</style>
